import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';

import { Button, Container, Header, Icon } from '~/components';
import { Field, Radio } from '~/components/Form';
import { routes } from '~/providers/RouterProvider/router.routes';
import { srOnlyStyle } from '~/styles/utilities.css';

import { actionsStyle, cardIconStyle, cardsRowStyle, containerStyle } from './ChooseClientType.css';

const clientTypes = ['organisation', 'private'] as const;

export const ChooseClientType = () => {
  const { t } = useTranslation(['clients']);

  const navigate = useNavigate();
  const { search } = useLocation();

  const [clientType, setClientType] = useState<(typeof clientTypes)[number] | null>(null);

  return (
    <>
      <Header.Root>
        <Header.Content backTo={routes.clients} title={t('clients:create.title')} />
      </Header.Root>

      <Container className={containerStyle}>
        <Field.Root name="clientType">
          <Radio.Group<(typeof clientTypes)[number] | null>
            className={cardsRowStyle}
            onValueChange={(value) => setClientType(value)}
            value={clientType}
          >
            <Radio.GroupLegend className={srOnlyStyle}>{t('clients:create.chooseType.title')}</Radio.GroupLegend>

            {clientTypes.map((type) => (
              <Radio.Root key={type} value={type}>
                <div className={cardIconStyle}>
                  <Icon name={type === 'organisation' ? 'Company' : 'Person'} size={30} />
                </div>

                <Radio.Label>{t(`clients:create.chooseType.${type}.title`)}</Radio.Label>
                <Radio.Description>{t(`clients:create.chooseType.${type}.description`)}</Radio.Description>
              </Radio.Root>
            ))}
          </Radio.Group>
        </Field.Root>

        <div className={actionsStyle}>
          <Button
            disabled={clientType === null}
            icon="ArrowRight"
            iconPlacement="right"
            onClick={() =>
              navigate({
                pathname: clientType === 'organisation' ? routes.createClientOrganisationStep : routes.createClientPrivateStep,
                search,
              })
            }
          >
            {t('clients:create.next')}
          </Button>
        </div>
      </Container>
    </>
  );
};
